/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationAcceptInvitationByTokenPathParams,
	OrganisationAcceptInvitationByTokenResponse,
} from '../types/OrganisationAcceptInvitationByToken'

/**
 * POST /organisations/invitations/accept-by-token/:token
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::acceptInvitationByToken
 */
export async function organisationAcceptInvitationByToken(
	token: OrganisationAcceptInvitationByTokenPathParams['token'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationAcceptInvitationByTokenResponse>> {
	return axiosInstance.post(`/organisations/invitations/accept-by-token/${token}`, undefined, config)
}
